<template>
    <v-btn large :disabled="!deveHabilitarBotoes" outline color="primary" @click.stop="$emit('savlarItensEAvancar')">
        Salvar e Avançar
        <v-icon left size="15" class="mx-1">arrow_forward_ios</v-icon>
    </v-btn>
</template>

<script>
export default {
    name: 'BotaoAvancarSalvarItens',
    props:['deveHabilitarBotoes']
}
</script>

<style scoped lang="stylus">

</style>